import React from 'react';
import PropTypes from 'prop-types';
import Schedules from '../../../../../common/schedulesForm/schedulesFormContainer';
import DownloadScheduleHistoryButton from '../../../containers/DownloadScheduleHistoryButton';
import Days from '../../../../../common/schedulesForm/daysContainer';

const Schedule = ({ canModify, schedules, daysOff, daysOn, minInterval, barberId }) => (
  <div className="u-mv" data-automation-id="schedule-tab">
    <div className="layout">
      <div className="layout__item u-1/2-large-and-up">
        <fieldset disabled={!canModify}>
          <Schedules schedules={schedules} minInterval={minInterval} />
        </fieldset>
      </div>
      <div className="layout__item u-1/2-large-and-up">
        <DownloadScheduleHistoryButton barberId={barberId} display-if={barberId} />
        <Days
          type="off"
          days={daysOff}
          barberId={barberId}
          disabled={!canModify}
        />
        <div className="c-separator u-mv" />
        <Days
          type="on"
          days={daysOn}
          barberId={barberId}
          disabled={!canModify}
        />
      </div>
    </div>
  </div>
);

Schedule.propTypes = {
  canModify: PropTypes.bool,
  minInterval: PropTypes.number,
  schedules: PropTypes.object.isRequired,
  daysOff: PropTypes.object.isRequired,
  daysOn: PropTypes.object.isRequired,
  barberId: PropTypes.string,
};

Schedule.defaultProps = {
  canModify: true,
  minInterval: 15,
  barberId: null,
};

export default Schedule;
